/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'resource-icon': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M119.273 487.87l79.243-48.22L512 629.12l313.484-189.47 79.243 48.22L512 725.6 119.273 487.87zm0-154.997L512 119.273l392.727 213.6L512 546.473l-392.727-213.6zM512 808.29l313.484-189.513 79.243 48.262L512 904.727 119.273 667.04l79.243-48.262L512 808.291z" _fill="#2c2c2c"/>'
  }
})
